var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDocumentLocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 13H22V11L21.71 10.29L20.71 9.29L20 9H16L15.29 9.29L14.29 10.29L14 11V13H13L12 14V21L12.29 21.71L14.29 23.71L15 24H21L21.71 23.71L23.71 21.71L24 21V14L23 13ZM16 11.41L16.41 11H19.58L19.99 11.41V13H15.99V11.41H16ZM22 20.58L20.59 21.99H15.42L14.01 20.58V14.99H22.01V20.58H22ZM16.5 17.99C16.5 17.16 17.17 16.49 18 16.49C18.83 16.49 19.5 17.16 19.5 17.99C19.5 18.82 18.83 19.49 18 19.49C17.17 19.49 16.5 18.82 16.5 17.99ZM4 17.99H10V19.99H3L2 18.99V1L3 0H17L18 1V7H16V2H4V18V17.99ZM6 5.99V3.99H14V5.99H6ZM6 7.99H12V9.99H6V7.99Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentLocked);
export default __webpack_public_path__ + "static/1776855102/media/icon-document-locked.467ca3f3308cfd679359ea36203e4f5c.svg";
export { ForwardRef as ReactComponent };